if (!window.customElements.get("page-dots")) {
  class PageDots extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll("button"));
      this.addEventListener("click", (event) => {
        this._dispatchEvent(this.buttons.indexOf(event.target));
      });
    }
    get selectedIndex() {
      return this.buttons.findIndex(
        (button) => button.getAttribute("aria-current") === "true"
      );
    }
    set selectedIndex(selectedIndex) {
      this.buttons.forEach((button, index) =>
        button.setAttribute(
          "aria-current",
          selectedIndex === index ? "true" : "false"
        )
      );
    }
    _dispatchEvent(index) {
      if (index !== this.selectedIndex) {
        this.dispatchEvent(
          new CustomEvent("page-dots:changed", {
            bubbles: true,
            detail: {
              index,
            },
          })
        );
      }
    }
  }
  window.customElements.define("page-dots", PageDots);
}

if (!window.customElements.get("native-carousel-item")) {
  class NativeCarouselItem extends HTMLElement {
    get index() {
      return [...this.parentNode.children].indexOf(this);
    }
  }
  window.customElements.define("native-carousel-item", NativeCarouselItem);
}

if (!window.customElements.get("native-carousel")) {
  class NativeCarousel extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll("native-carousel-item"));
      this.pageDotsElements = Array.from(this.querySelectorAll("page-dots"));
      if (this.items.length > 1) {
        this.addEventListener("page-dots:changed", (event) =>
          this.select(event.detail.index)
        );
      }
      const scrollerElement = this.items[0].parentElement;
      this.intersectionObserver = new IntersectionObserver(
        this._onVisibilityChanged.bind(this),
        {
          root: scrollerElement,
          rootMargin: `${scrollerElement.clientHeight}px 0px`,
          threshold: 0.8,
        }
      );
      this.items.forEach((item) => this.intersectionObserver.observe(item));
    }
    disconnectedCallback() {
      this.intersectionObserver.disconnect();
    }
  
    select(index) {
      const clampIndex = Math.max(0, Math.min(index, this.items.length));
      const selectedElement = this.items[clampIndex];
      this._adjustNavigationForElement(selectedElement);
      this.items.forEach(
        (item, loopIndex) => (item.selected = loopIndex === clampIndex)
      );
      selectedElement.parentElement.scrollTo({
        left: selectedElement.clientWidth * clampIndex,
        behavior: "smooth",
      });
    }
  
    _adjustNavigationForElement(selectedElement) {
      this.pageDotsElements.forEach(
        (pageDot) => (pageDot.selectedIndex = selectedElement.index)
      );
    }
    _onVisibilityChanged(entries) {
      for (let entry of entries) {
        if (entry.isIntersecting) {
          this._adjustNavigationForElement(entry.target);
          break;
        }
      }
    }
  }
  window.customElements.define("native-carousel", NativeCarousel);
}
